import { hasReadableContrast } from '@shared/utils/color';

/** The button's backing: near-opaque white, so contrast is judged against white. */
export const STALL_BUTTON_BACKING = 'rgba(255, 255, 255, 0.72)';
// WCAG 1.4.11 non-text contrast minimum for a control's glyph.
const MIN_GLYPH_CONTRAST = 3;
/** Neutral theme token used when the event accent would vanish on the light backing. */
export const STALL_GLYPH_FALLBACK = 'mono12';

/**
 * Glyph colour for the stall Play button: the event accent when it reads on the light backing,
 * otherwise a neutral dark token. A white or pale accent (e.g. a light palette) on the white
 * backing would hide the only way to start a blocked video.
 */
export const getStallGlyphColor = (accentColor: string | undefined): string =>
  accentColor && hasReadableContrast('#ffffff', accentColor, MIN_GLYPH_CONTRAST) ? accentColor : STALL_GLYPH_FALLBACK;
